import { useDataSubmit } from 'Simple/Data.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'

export function isDisabled(valid, isSubmitting) {
  return !valid || !!isSubmitting
}

export function useOnClick(props) {
  let [, notify] = useNotifications()

  let submitPayment = useDataSubmit({
    context: 'payment',
    viewPath: props.viewPath,
  })

  let submitCreditCardCapture = useDataSubmit({
    context: 'credit_card_capture',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    let token = await submitPayment({ type: 'tokenize' })
    if (!token || token === true) {
      notify(notifyError('Could not tokenize the card. Please try again.'))
      return
    }

    await submitCreditCardCapture({ type: 'authorize_card', token })
  }
}
